import toArrow from '../arrow/encode';
export default toArrow;